/**
 * Vuex 状态管理入口（学校端）
 * 注册 theme（主题配置）和 user（用户登录状态）两个子模块
 */
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import theme from './modules/theme';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    theme,
    user,
  },
  getters,
});
